import { useState, useEffect } from "react";
import { getReviews } from "./api";
import { REVIEWS, BUSINESS } from "./data";

const GOOGLE_REVIEWS_URL = "https://search.google.com/local/reviews?placeid=ChIJf9hWsWJj_ogRKMEHHSYg6z0";

// Live Google reviews with graceful fallback to bundled snapshot.
export function useReviews() {
  const [data, setData] = useState({
    reviews: REVIEWS,
    rating: BUSINESS.rating,
    reviewCount: BUSINESS.reviewCount,
    googleUrl: GOOGLE_REVIEWS_URL,
    live: false,
  });

  useEffect(() => {
    let mounted = true;
    getReviews()
      .then((d) => {
        if (!mounted) return;
        if (d && d.configured && Array.isArray(d.reviews) && d.reviews.length) {
          setData({
            reviews: d.reviews.map((r) => ({
              name: r.name || "Google user",
              date: r.date || "",
              stars: r.stars || 5,
              text: r.text || "",
              photo: r.photo || null,
            })),
            rating: d.rating != null ? Number(d.rating).toFixed(1) : BUSINESS.rating,
            reviewCount: d.review_count != null ? String(d.review_count) : BUSINESS.reviewCount,
            googleUrl: d.google_url || GOOGLE_REVIEWS_URL,
            live: true,
          });
        }
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return data;
}
